/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["o poln.","nap.","ráno","dop.","pop.","več.","v n."],["o poln.","napol.","ráno","dopol.","popol.","večer","v noci"],["o polnoci","napoludnie","ráno","dopoludnia","popoludní","večer","v noci"]],[["poln.","pol.","ráno","dop.","pop.","več.","noc"],["poln.","pol.","ráno","dopol.","popol.","večer","noc"],["polnoc","poludnie","ráno","dopoludnie","popoludnie","večer","noc"]],["00:00","12:00",["04:00","09:00"],["09:00","12:00"],["12:00","18:00"],["18:00","22:00"],["22:00","04:00"]]];
